import { Typography } from "@packages/ds";
import styled from "styled-components";

import EmptyTree from "src/organization/common/containers/ServicesDisplay/EmptyTree";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Tree = styled(EmptyTree)`
  margin: 60px auto;
`;

export const Code = styled(Typography.Code)`
  margin: unset;
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 32px;
  text-transform: capitalize;
`;

export const EmptyServicesTitle = styled(Typography.Title)`
  margin: 18px 0;
`;
